<template>
  <cupertino-alert-dialog :title="$t('novelDetail.updateConfirm.title')" :close="onClickOutSide">
    <template v-slot:content>
      <div class="px-1 py-1">
        {{ content }}
      </div>
    </template>
    <template v-slot:actions>
      <div class="flex flex-row flex-center flex-spacearound">
        <div
          class="w-full border-right-1 flex flex-center pointer py-1 hover left-bottom-radius-10"
          @click="onCancelClick"
        >
          <span>{{ $t("common.cancel") }}</span>
        </div>
        <div class="w-full flex flex-center pointer py-1 hover right-bottom-radius-10" @click="onUpdateClick">
          <span class="color-blue bold">{{ $t("novelDetail.updateConfirm.overwriteButton") }}</span>
        </div>
      </div>
    </template>
  </cupertino-alert-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import CupertinoAlertDialog from "@/components/ui/dialogs/CupertinoAlertDialog.vue";

interface Methods {
  onClickOutSide: () => void;
  onCancelClick: () => void;
  onUpdateClick: () => void;
}

interface Props {
  id: string;
  content: string;
}

export default Vue.extend<{}, Methods, {}, Props>({
  components: { CupertinoAlertDialog },

  methods: {
    onClickOutSide() {
      this.$close(false);
    },
    onCancelClick() {
      this.$close(false);
    },
    onUpdateClick() {
      this.$close(true);
    },
  },

  props: {
    id: String,
    content: String,
  },
});

export type NolaNovelUpdateConfirmProps = Props;
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

// content
.w-full {
  width: 100%;
}

// flex

.flex {
  display: flex;
}

.flex-row {
  flex-direction: row;
}

.flex-center {
  align-items: center;
  justify-content: center;
}

.flex-spacearound {
  justify-content: space-around;
}

// button

.pointer {
  cursor: pointer;
}

.hover {
  position: relative;
  @include hover-overlay;
}

// text
.bold {
  font-weight: var(--font-weight-bold);
}

// padding, margin

.px-1 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-1 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

// border

.border-right-1 {
  border-right: solid 1px var(--color-border);
}

.left-bottom-radius-10 {
  border-radius: 0px 0px 0px var(--radius-sm);
}

.right-bottom-radius-10 {
  border-radius: 0px 0px var(--radius-sm) 0px;
}

// color

.color-blue {
  color: var(--color-primary);
}
</style>
